export default "__VITE_ASSET__uRoDgMPd__"